import { api } from "./client";
import type { User, UserCreate, UserUpdate } from "@/types";

export const usersApi = {
  async list(params?: { tenant_id?: string }): Promise<User[]> {
    const { data } = await api.get<User[]>("/users", { params });
    return data;
  },
  async get(id: string): Promise<User> {
    const { data } = await api.get<User>(`/users/${id}`);
    return data;
  },
  async create(payload: UserCreate): Promise<User> {
    const { data } = await api.post<User>("/users", payload);
    return data;
  },
  async update(id: string, payload: UserUpdate): Promise<User> {
    const { data } = await api.patch<User>(`/users/${id}`, payload);
    return data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },
  /** Reenvia o e-mail de boas-vindas com link novo de "Criar minha senha". */
  async reenviarConvite(id: string): Promise<{ detail: string }> {
    const { data } = await api.post<{ detail: string }>(`/users/${id}/convite`);
    return data;
  },
};
